export var AuthRole;
(function (AuthRole) {
    AuthRole["StoreManager"] = "StoreManager";
    AuthRole["HeadOfficeAdmin"] = "HeadOfficeAdmin";
    AuthRole["Any"] = "Any";
})(AuthRole || (AuthRole = {}));
